// GENERATED FILE. Do not edit by hand. Produced by `bun run codegen`.

import Ajv from "ajv";
import addFormats from "ajv-formats";
import call from "../../sdk-helpers/call";
import { logError } from "../../sdk-helpers/shouldLog";

export type typeAwardCustomDeleteBody = {
  poolId: string;
  awardTypeId: string;
};

export type typeAwardCustomDeleteOutput200 = {
  error?: {
    code: string;
    message: string;
    details?: Record<string, unknown>;
  } | null;
  data?: null | { grantsDeleted: number; membersAffected: number };
};

export type typeAwardCustomDeleteOutput400 = {
  error: {
    code: string;
    message: string;
    details?: Record<string, unknown>;
  } | null;
  data: null;
};

export type typeAwardCustomDeleteOutput401 = {
  error: {
    code: string;
    message: string;
    details?: Record<string, unknown>;
  } | null;
  data: null;
};

export type typeAwardCustomDeleteOutput500 = {
  error: {
    code: string;
    message: string;
    details?: Record<string, unknown>;
  } | null;
  data: null;
};

export const schemaAwardCustomDeleteBody = {
  type: "object",
  properties: {
    poolId: { type: "string", maxLength: 3000, minLength: 1 },
    awardTypeId: { type: "string", maxLength: 3000, minLength: 1 },
  },
  required: ["poolId", "awardTypeId"],
} as const;

export type SdkOptions = {
  headers?: Record<string, string>;
  apiHost?: string;
  prefix?: string;
};

let compiledValidator: ReturnType<Ajv["compile"]> | null = null;

export default function createAwardCustomDelete(options: SdkOptions) {
  if (!compiledValidator) {
    const ajv = new Ajv({ strict: false });
    addFormats(ajv);
    compiledValidator = ajv.compile(schemaAwardCustomDeleteBody);
  }

  return async function postAwardCustomDelete(
    payload: typeAwardCustomDeleteBody,
  ): Promise<typeAwardCustomDeleteOutput200 | typeAwardCustomDeleteOutput400> {
    const isValid = compiledValidator!(payload);
    if (!isValid) {
      logError(
        `Payload validation inside SDK method "postAwardCustomDelete" failed before calling the network. #b20093bbdf4d`,
        compiledValidator!.errors,
      );
      return {
        error: {
          code: "VALIDATION_ERROR",
          message: "Request payload failed schema validation.",
          details: { errors: compiledValidator!.errors, ref: "#b20093bbdf4d" },
        },
        data: null,
      } as typeAwardCustomDeleteOutput400;
    }

    const prefix = options?.prefix ?? "";
    return (await call({
      payload,
      endpoint: `${prefix}/award/custom-delete`,
      httpMethod: "POST",
      options,
    })) as typeAwardCustomDeleteOutput200 | typeAwardCustomDeleteOutput400;
  };
}
